import { render, staticRenderFns } from "./dcReturnWindow.vue?vue&type=template&id=3c6d984e&scoped=true&"
import script from "./dcReturnWindow.vue?vue&type=script&lang=js&"
export * from "./dcReturnWindow.vue?vue&type=script&lang=js&"
import style0 from "./dcReturnWindow.vue?vue&type=style&index=0&id=3c6d984e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6d984e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c6d984e')) {
      api.createRecord('3c6d984e', component.options)
    } else {
      api.reload('3c6d984e', component.options)
    }
    module.hot.accept("./dcReturnWindow.vue?vue&type=template&id=3c6d984e&scoped=true&", function () {
      api.rerender('3c6d984e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/DocumentCirculation/dcReturnWindow.vue"
export default component.exports